<template>
   <div class="crud-wrapper">
      <crud-toolbar :isBlocked="formData.blocked" :modal-mode="modalMode" :new-state="newState"
                    :title="modalTitle" @onCommand="toolbarCommand"
                    showBlock></crud-toolbar>

      <crud-form :modal-mode="modalMode" :ref="formName" full-width v-model="validForm">

         <v-layout row wrap>
            <a-autocomplete-field :modalForm="BankForm" allowEdit allowNew autoTrigger label="Banco" obj="bank"
                                  sm8 v-model="formData.bankId" validate="required">
               <template slot="content" slot-scope="{data}">
                  <v-layout column>
                     <v-list-tile-title>
                        {{data.bankNo}} <span style="margin: 0 10px;">-</span> {{data.name}}
                     </v-list-tile-title>
                  </v-layout>
               </template>
            </a-autocomplete-field>

            <a-select-field label="Convênio" obj="covenant" sm4
                            v-model="formData.covenantId" validate="required"></a-select-field>

            <a-text-field label="Nome da Tabela" sm8 text-transform="capitalize" v-model="formData.name"
                          validate="required"></a-text-field>
            <a-text-field label="Código" sm4 v-model="formData.code"></a-text-field>


            <v-flex sm8 xs12 v-if="formData.id">

               <a-detail-grid :columns="termCols" :newItemData="{}" :parentKey="{chartId: formData.id}" :filter-by="{chartId: formData.id}" :pager="{rowsPerPage: -1}"
                              hide-actions obj="bankChartTerms" @onChange="onChangeTerms" @onRowClick="showDetails"
                              title="Prazos e Comissões">
                  <template slot="editForm" slot-scope="{data}">
                     <a-text-field autofocus label="Prazo" sm3 v-mask="'###'" v-model="data.term"></a-text-field>
                     <a-number-field label="Coeficiente Único" sm9 v-mask="['#,######','#,#######','#,########']"
                                   v-model="data.factor"></a-number-field>
                     <!-- <a-number-field label="Comissão" number-mask="p_rs" numberDecimals="1" sm4
                                     v-model="data.commission"></a-number-field>
                     <a-number-field label="Comissão S.Dev" number-mask="p_rs" numberDecimals="1" sm4
                                     v-model="data.commission_sd"></a-number-field>
                     <a-number-field label="Comissão Liq Ref Porta" number-mask="p_rs" numberDecimals="1" sm4
                                     v-model="data.commission_lrp"></a-number-field> -->
                  </template>

                  <template slot="rows" slot-scope="{data}">
                     <td class="text-xs-center">{{ data.item.term }}</td>
                     <td class="text-xs-right">{{ data.item.factor }}</td>
                     <!-- <td class="text-xs-right">{{ data.item.commission | fmtPercent }}</td>
                     <td class="text-xs-right">{{ data.item.commission_sd | fmtPercent }}</td>
                     <td class="text-xs-right">{{ data.item.commission_lrp | fmtPercent }}</td> -->
                  </template>
               </a-detail-grid>

               <!--<a-data-grid :columns="termCols" :filter-by="{chartId: formData.id}" :options="termOptions"
                            @onRowClick="showDetails"
                            class="mt-2" height="300px" obj="bankChart/terms"></a-data-grid>-->
            </v-flex>

            <v-flex sm4 xs12 v-if="selectedTermId">
               <a-detail-grid :columns="detailCols" :newItemData="{day: $moment().format('YYYY-MM-DD')}"  :parentKey="{termId: selectedTermId}"  :filter-by="{termId: selectedTermId}" :pager="{rowsPerPage: -1}"
                              :title="`Coeficientes Diários ${selectedTermId ? ('('+selectedTerm+')') : ''}`"

                              obj="bankChartDetails">

                  <template slot="editForm" slot-scope="{data}">
                     <a-text-field autofocus label="Dia" sm3 v-mask="'####-##-##'" v-model="data.day"></a-text-field>
                     <a-number-field label="Coeficiente Diário" sm9 v-mask="['#,######','#,#######','#,########']"
                                   v-model="data.factor"></a-number-field>
                  </template>

                  <template slot="rows" slot-scope="{data}">
                     <td class="text-xs-center">{{ data.item.day }}</td>
                     <td class="text-xs-right">{{ data.item.factor }}</td>
                  </template>
               </a-detail-grid>
               <!-- <div v-if="selectedTermId === null" style="color:black">selecione um prazo para ver a lista de fatores</div> -->
            </v-flex>


         </v-layout>


      </crud-form>

   </div>


</template>

<script>
   import CrudFormClass from '@consigmais-team/vue-common/layout/crudPage/crudFormClass';
   import BankForm from './BankForm';


   let numeral = require('numeral');

   export default CrudFormClass.extend({
      name: 'BankChartForm',

      data: function () {
         return {
            title: 'Tabela',
            formName: 'bankChartForm',
            BankForm,

            formData: {
               id: null,
               bankId: null,
               covenantId: null,
               code: null,
               name: null,
               expiry_at: null,
               created_by: null
            },

            selectedTermId: null,
            selectedTerm: null,

            termCols: [
               {
                  value: 'term',
                  text: 'Prazo',
                  align: 'center',
                  dataType: 'number',
                  sortable: true
               },
               {
                  value: 'factor',
                  text: 'Coeficiente Único',
                  align: 'right',
                  sortable: true
               },
               // {
               //    value: 'commission',
               //    text: 'Comissão',
               //    align: 'right',
               //    sortable: true,
               //    dataType: 'number'
               // },
               // {
               //    value: 'commission_sd',
               //    text: 'Comissão SD',
               //    align: 'right',
               //    dataType: 'number',
               //    sortable: true
               // },
               // {
               //    value: 'commission_lrp',
               //    text: 'Comissão LRP',
               //    align: 'right',
               //    dataType: 'number',
               //    sortable: true
               // }
            ],

            detailCols: [
               {
                  value: 'day',
                  text: 'Dia',
                  alignment: 'center',
                  width: '100'
               },
               {
                  value: 'factor',
                  text: 'Coeficiente',
                  alignment: 'center'
               }
            ],

            termOptions: {
               editing: {
                  allowAdding: true,
                  allowUpdating: true,
                  allowDeleting: true,
                  mode: 'batch',
                  useIcons: true
               }
            }


         };
      },

      computed: {
         maxDate () {
            return '2002-01-01';
         }
      },

      methods: {
         onChangeTerms(itens){
            if(this.selectedTermId == null){
               if(itens && itens.length){
                  this.selectedTermId = itens[0].id;
                  this.selectedTerm = itens[0].term;
               }

            }
         },
         showDetails (item) {
            this.log('termClick:', item);
            this.selectedTermId = item.id;
            this.selectedTerm = item.term;
         },

         getSome (data) {
            this.log('rows Slot: ', data);
            return data.term;
         }

      },

      mounted () {
         // console.log(this.modalMode, this.modalTitle);
      }

   });
</script>

<style scoped>


</style>




// WEBPACK FOOTER //
// src/pages/BankChartForm.vue